var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isMobbileView || _vm.isTabletView
      ? _c("div", { staticClass: "usage-detail__date-navigation-mobile" }, [
          _c(
            "div",
            {
              staticClass:
                "usage-detail__date-navigation-mobile__controls-container"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "usage-detail__date-navigation-mobile__controls-container__row usage-detail__primary-controls"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "usage-detail__date-navigation-mobile__controls-container__row__col"
                    },
                    [
                      _vm.showComparisonDetails
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "usage-detail__date-navigation__comparison-container-mobile"
                            },
                            [
                              _vm.comparisonDetailsType
                                ? _c(
                                    "div",
                                    { staticClass: "comparison-details" },
                                    [_vm._v(_vm._s(_vm.comparisonDetailsType))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comparisonDetailsDate
                                ? _c(
                                    "div",
                                    { staticClass: "comparison-details" },
                                    [_vm._v(_vm._s(_vm.comparisonDetailsDate))]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedDate
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "usage-detail__date-navigation-mobile__selected-date-container"
                            },
                            [
                              _vm.selectedDate
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "usage-detail__date-navigation-mobile__selected-date-container__selected-date"
                                    },
                                    [_vm._v(_vm._s(_vm.selectedDate))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedDateSubText
                                ? _c("div", {
                                    staticClass:
                                      "usage-detail__date-navigation-mobile__selected-date-container__selected-date-sub-text",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.selectedDateSubText)
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "usage-detail__date-navigation-mobile__controls-container__row__col"
                    },
                    [
                      _vm.showDateBackwardsButton
                        ? _c("DateNavigationButtonBack", {
                            staticClass: "usage-detail__date-navigation-item",
                            attrs: {
                              goBack: _vm.onDateBackwardsClicked,
                              disabled:
                                _vm.disableAllDateNavControls ||
                                _vm.disableDateNavigationButtonBack
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDateForwardsButton
                        ? _c("DateNavigationButtonForward", {
                            staticClass: "usage-detail__date-navigation-item",
                            attrs: {
                              goForward: _vm.onDateForwardsClicked,
                              disabled:
                                _vm.disableAllDateNavControls ||
                                _vm.disableDateNavigationButtonForward
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "usage-detail__date-navigation-mobile__controls-container__wrapper"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "usage-detail__date-navigation-mobile__controls-container__row"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "usage-detail__date-navigation-item-mobile__view-options",
                          on: {
                            click: function($event) {
                              return _vm.toggleMobileViewOptionsVisible()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.mobileViewOptionsVisible
                                  ? "Hide Controls"
                                  : "Show Controls"
                              ) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass:
                              "usage-detail__date-navigation-item-mobile__view-options__caret",
                            class: {
                              "caret-up": _vm.mobileViewOptionsVisible,
                              "caret-down": !_vm.mobileViewOptionsVisible
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.mobileViewOptionsVisible
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "usage-detail__date-navigation-mobile__controls-container__row gds-flex-container--left"
                        },
                        [
                          _vm.showJumpToDateButton
                            ? _c("DateNavigationButtonMobile", {
                                staticClass:
                                  "usage-detail__date-navigation-item",
                                attrs: {
                                  buttonText: "Go To Date",
                                  buttonClicked: _vm.showDatePicker,
                                  disabled:
                                    _vm.disableAllDateNavControls ||
                                    _vm.disableDateNavigationButtonJumpToDate
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showComparisonDateButton
                            ? _c("DateNavigationButtonMobile", {
                                staticClass:
                                  "usage-detail__date-navigation-item",
                                attrs: {
                                  buttonText: "Comparison Date",
                                  buttonClicked: _vm.showDatePickerSecondary,
                                  disabled:
                                    _vm.disableAllDateNavControls ||
                                    _vm.disableDateNavigationButtonCalendar
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSimpleDatePickerButton
                            ? _c("DateNavigationButtonMobile", {
                                staticClass:
                                  "usage-detail__date-navigation-item",
                                attrs: {
                                  buttonText: "Go To Date",
                                  buttonClicked: _vm.showDatePicker,
                                  disabled:
                                    _vm.disableAllDateNavControls ||
                                    _vm.disableDateNavigationButtonCalendar
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showGoToTodayButton
                            ? _c("DateNavigationButtonMobile", {
                                staticClass:
                                  "usage-detail__date-navigation-item",
                                attrs: {
                                  buttonText: "Go To Today",
                                  buttonClicked: _vm.onGoToTodayClicked,
                                  disabled:
                                    _vm.disableAllDateNavControls ||
                                    _vm.disableDateNavigationButtonGoToToday
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showViewOptionsButton
                            ? _c("DateNavigationButtonMobile", {
                                staticClass:
                                  "usage-detail__date-navigation-item",
                                attrs: {
                                  buttonText: _vm.viewOptionsLabel,
                                  buttonClicked: _vm.onViewOptionsClicked,
                                  disabled:
                                    _vm.disableAllDateNavControls ||
                                    _vm.disableDateNavigationButtonGoToToday
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectConfigMonthlyDailyHourly
                            ? _c("UsageDetailSelectMobile", {
                                attrs: {
                                  addBackground: true,
                                  modalTitle: "Compare Granularity",
                                  config: _vm.selectConfigMonthlyDailyHourly,
                                  disabled: _vm.disableAllDateNavControls,
                                  optionSelected:
                                    _vm.onOptionSelectedMonthlyDailyHourly
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectConfigUsageType
                            ? _c("UsageDetailSelectMobile", {
                                attrs: {
                                  addBackground: true,
                                  modalTitle: "Data Series",
                                  config: _vm.selectConfigUsageType,
                                  disabled: _vm.disableAllDateNavControls,
                                  optionSelected: _vm.onOptionSelectedUsageType
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectConfigTableSort
                            ? _c("UsageDetailSelectMobile", {
                                attrs: {
                                  addBackground: true,
                                  modalTitle: "Sort Order",
                                  config: _vm.selectConfigTableSort,
                                  disabled: _vm.disableAllDateNavControls,
                                  optionSelected: _vm.onOptionSelectedTableSort
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectConfigCalendarMonthsBillingPeriod
                            ? _c("UsageDetailSelectMobile", {
                                attrs: {
                                  addBackground: true,
                                  modalTitle: "Time Grouping",
                                  disabled: _vm.disableAllDateNavControls,
                                  config:
                                    _vm.selectConfigCalendarMonthsBillingPeriod,
                                  optionSelected:
                                    _vm.onOptionSelectedCalendarMonthsBillingPeriod
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectConfigCheckboxes
                            ? _c("UsageDetailCheckboxes", {
                                attrs: {
                                  addBackground: true,
                                  buttonText:
                                    _vm.selectConfigCheckboxes.buttonText ||
                                    "Options",
                                  modalTitle:
                                    _vm.selectConfigCheckboxes.modalTitle ||
                                    "Please Select",
                                  disabled: _vm.disableAllDateNavControls,
                                  config: _vm.selectConfigCheckboxes,
                                  checkboxChanged: _vm.onCheckboxesModalChange
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.showSimpleDatePickerButton ||
                            _vm.showJumpToDateButton) &&
                          _vm.datePickerVisible
                            ? _c("UsageDetailDatePickerMobile", {
                                attrs: {
                                  modalTitle: "Go To Date",
                                  closeModal: _vm.closeDatePickers,
                                  datePickerDefaultDate:
                                    _vm.datePickerDefaultDate,
                                  datePickerVisible: _vm.datePickerVisible,
                                  datePickerDateType: _vm.datePickerDateType,
                                  disabled: _vm.disableAllDateNavControls,
                                  disabledDates: _vm.datePickerDisabledDates,
                                  selectedDateChanged: _vm.onSelectedDateChanged
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.showSimpleDatePickerButton ||
                            _vm.showJumpToDateButton) &&
                          _vm.datePickerVisibleSecondary
                            ? _c("UsageDetailDatePickerMobile", {
                                attrs: {
                                  modalTitle: "Comparison Date",
                                  closeModal: _vm.closeDatePickers,
                                  datePickerDefaultDate:
                                    _vm.datePickerDefaultDateSecondary,
                                  datePickerVisible:
                                    _vm.datePickerVisibleSecondary,
                                  datePickerDateType: _vm.datePickerDateType,
                                  disabled: _vm.disableAllDateNavControls,
                                  disabledDates:
                                    _vm.datePickerDisabledDatesSecondary,
                                  selectedDateChanged:
                                    _vm.onSelectedDateChangedSecondary
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAccountSwitcher
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "usage-detail__account-switcher-container"
                                },
                                [
                                  _vm._v("Viewing usage for "),
                                  _c("widget-account-switcher", {
                                    attrs: { minified: true }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isDesktopView
      ? _c("div", { staticClass: "usage-detail__header-content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.closeDatePickers,
                  expression: "closeDatePickers"
                }
              ],
              staticClass: "usage-detail-controls-container"
            },
            [
              _c("div", { staticClass: "usage-detail__primary-controls" }, [
                _c("div", { staticClass: "usage-detail__primary-title" }, [
                  _vm.selectedDate
                    ? _c(
                        "div",
                        {
                          staticClass: "usage-detail__selected-date-container"
                        },
                        [
                          _vm.selectedDate
                            ? _c(
                                "h2",
                                {
                                  staticClass:
                                    "usage-detail__selected-date-container__selected-date"
                                },
                                [_vm._v(_vm._s(_vm.selectedDate))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedDateSubText
                            ? _c("div", {
                                staticClass:
                                  "usage-detail__selected-date-container__selected-date-sub-text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.selectedDateSubText)
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCompareRoute && _vm.showComparisonDetails
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "usage-detail__date-navigation__comparison-container-desktop"
                        },
                        [
                          _vm.comparisonDetailsType
                            ? _c("div", { staticClass: "comparison-details" }, [
                                _vm._v(_vm._s(_vm.comparisonDetailsType))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.comparisonDetailsDate
                            ? _c("div", { staticClass: "comparison-details" }, [
                                _vm._v(_vm._s(_vm.comparisonDetailsDate))
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCompareRoute && _vm.selectedDate
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "usage-detail__date-navigation-mobile__selected-date-container"
                        },
                        [
                          _vm.selectedDate
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "usage-detail__date-navigation-mobile__selected-date-container__selected-date"
                                },
                                [_vm._v(_vm._s(_vm.selectedDate))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedDateSubText
                            ? _c("div", {
                                staticClass:
                                  "usage-detail__date-navigation-mobile__selected-date-container__selected-date-sub-text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.selectedDateSubText)
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "usage-detail__secondary-controls" }, [
                _c(
                  "div",
                  { staticClass: "usage-detail-controls-container__left-side" },
                  [
                    _vm.showDateBackwardsButton
                      ? _c("DateNavigationButtonBack", {
                          staticClass: "usage-detail__date-navigation-item",
                          attrs: {
                            goBack: _vm.onDateBackwardsClickedHandler,
                            disabled:
                              _vm.disableAllDateNavControls ||
                              _vm.disableDateNavigationButtonBack
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showDateForwardsButton
                      ? _c("DateNavigationButtonForward", {
                          staticClass: "usage-detail__date-navigation-item",
                          attrs: {
                            goForward: _vm.onDateForwardsClickedHandler,
                            disabled:
                              _vm.disableAllDateNavControls ||
                              _vm.disableDateNavigationButtonForward
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm.showSimpleDatePickerButton ||
                        _vm.showJumpToDateButton
                          ? _c("UsageDetailDatePicker", {
                              attrs: {
                                datePickerDefaultDate:
                                  _vm.datePickerDefaultDate,
                                datePickerVisible: _vm.datePickerVisible,
                                datePickerDateType: _vm.datePickerDateType,
                                disabled: _vm.disableAllDateNavControls,
                                disabledDates: _vm.datePickerDisabledDates,
                                selectedDateChanged: _vm.onSelectedDateChanged
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showSimpleDatePickerButton
                      ? _c("DateNavigationButtonCalendar", {
                          staticClass: "usage-detail__date-navigation-item",
                          attrs: {
                            showCalendar: _vm.showDatePicker,
                            disabled:
                              _vm.disableAllDateNavControls ||
                              _vm.disableDateNavigationButtonCalendar
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showJumpToDateButton
                      ? _c("DateNavigationButtonJumpToDate", {
                          staticClass: "usage-detail__date-navigation-item",
                          attrs: {
                            jumpToDate: _vm.showDatePicker,
                            buttonLabel: _vm.jumpToDateButtonLabel,
                            disabled:
                              _vm.disableAllDateNavControls ||
                              _vm.disableDateNavigationButtonJumpToDate
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showComparisonDateButton
                      ? _c("DateNavigationButtonJumpToDate", {
                          staticClass: "usage-detail__date-navigation-item",
                          attrs: {
                            jumpToDate: _vm.showDatePickerSecondary,
                            buttonLabel: "Comparison Date",
                            disabled:
                              _vm.disableAllDateNavControls ||
                              _vm.disableDateNavigationButtonJumpToDate
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showGoToTodayButton
                      ? _c("DateNavigationButtonGoToToday", {
                          staticClass: "usage-detail__date-navigation-item",
                          attrs: {
                            goToToday: _vm.onGoToTodayClickedHandler,
                            disabled:
                              _vm.disableAllDateNavControls ||
                              _vm.disableDateNavigationButtonGoToToday
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm.showComparisonDateButton
                          ? _c("UsageDetailDatePicker", {
                              attrs: {
                                datePickerDefaultDate:
                                  _vm.datePickerDefaultDateSecondary,
                                datePickerVisible:
                                  _vm.datePickerVisibleSecondary,
                                datePickerDateType: _vm.datePickerDateType,
                                disabled: _vm.disableAllDateNavControls,
                                disabledDates:
                                  _vm.datePickerDisabledDatesSecondary,
                                selectedDateChanged:
                                  _vm.onSelectedDateChangedSecondary
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.summaryText
                      ? _c("span", {
                          staticClass: "usage-detail__performance-summary",
                          domProps: { innerHTML: _vm._s(_vm.summaryText) }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "usage-detail-controls-container__right-side"
                  },
                  [
                    _vm.selectConfigTableSort
                      ? _c("UsageDetailSelect", {
                          attrs: {
                            config: _vm.selectConfigTableSort,
                            optionSelected: _vm.onOptionSelectedTableSort
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectConfigConsumptionOrGeneration
                      ? _c("UsageDetailSelect", {
                          attrs: {
                            config: _vm.selectConfigConsumptionOrGeneration,
                            optionSelected:
                              _vm.onOptionSelectedConsumptionOrGeneration
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectConfigCalendarMonthsBillingPeriod
                      ? _c("UsageDetailSelect", {
                          attrs: {
                            config: _vm.selectConfigCalendarMonthsBillingPeriod,
                            optionSelected:
                              _vm.onOptionSelectedCalendarMonthsBillingPeriod
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectConfigMonthlyDailyHourly
                      ? _c("UsageDetailSelect", {
                          attrs: {
                            config: _vm.selectConfigMonthlyDailyHourly,
                            optionSelected:
                              _vm.onOptionSelectedMonthlyDailyHourlyHandler
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectConfigUsageType
                      ? _c("UsageDetailSelect", {
                          attrs: {
                            config: _vm.selectConfigUsageType,
                            optionSelected: _vm.onOptionSelectedUsageType
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectConfigCheckboxes
                      ? _c("UsageDetailCheckboxes", {
                          attrs: {
                            addBackground: true,
                            buttonText:
                              _vm.selectConfigCheckboxes.buttonText ||
                              "Options",
                            modalTitle:
                              _vm.selectConfigCheckboxes.modalTitle ||
                              "Please Select",
                            disabled: _vm.disableAllDateNavControls,
                            config: _vm.selectConfigCheckboxes,
                            checkboxChanged: _vm.onCheckboxesModalChange
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showViewOptionsButton
                      ? _c("ButtonViewOptions", {
                          attrs: {
                            viewOptionsLabel: _vm.viewOptionsLabel
                              ? _vm.viewOptionsLabel
                              : "View Options",
                            viewOptions: _vm.onViewOptionsClicked
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showAccountSwitcher
            ? _c(
                "div",
                { staticClass: "usage-detail__account-switcher-container" },
                [
                  _vm._v("Viewing usage for "),
                  _c("widget-account-switcher", { attrs: { minified: true } })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }